<app-card cardTitle="Aggiungi una nuova Interaction" [options]="false" >
    <div class="row" *ngIf="!startConfigInteraction">
        <div
            class="col-12 d-flex flex-row justify-content-space-between flex-wrap">
            <div class="interactionType"
            *ngFor="let type of availableInteractionTypes"
            [class.active]="interactionType.value === type.value"
            (click)="interactionType = type">
                <app-custom-icons [icon]="type.value + '.svg'" [color]="interactionType.value === type.value ? '#ffffff' : '#E97E97'" [size]="'14px'" class="d-inline-block mr-3"></app-custom-icons>
                <strong [class.text-white]="interactionType.value === type.value">{{type.label}}</strong>
                <img [src]="'assets/images/interaction-types/' + type.image" class="img-fluid d-block mt-1 mx-auto">
            </div>
        </div>
        <div class="col-12 mt-3">
            <h6 class="text-uppercase">{{interactionType.label}}</h6>
            <p [innerHTML]="interactionType.description"></p>
        </div>
        <div class="col-sm-12 d-flex justify-content-end mt-5">
            <button type="button" class="btn btn-primary" (click)="startConfigInteraction = true">AVANTI</button>
        </div>
    </div>

    <!-- CONFIG INTERACTION -->
    <div *ngIf="startConfigInteraction">
        <app-quiz *ngIf="interactionType.value === 'quiz'" (addInteraction)="addInteraction($event)"></app-quiz>
        <app-left-right *ngIf="interactionType.value === 'leftRight'" (addInteraction)="addInteraction($event)"></app-left-right>
        <app-memory *ngIf="interactionType.value === 'memory'" (addInteraction)="addInteraction($event)"></app-memory>
        <app-quadrato-magico *ngIf="interactionType.value === 'quadratoMagico'" (addInteraction)="addInteraction($event)"></app-quadrato-magico>
        <app-indovina-parola *ngIf="interactionType.value === 'indovinaParola'" (addInteraction)="addInteraction($event)"></app-indovina-parola>
        <app-statica *ngIf="interactionType.value === 'statica'" (addInteraction)="addInteraction($event)"></app-statica>
        <app-video *ngIf="interactionType.value === 'video'" (addInteraction)="addInteraction($event)"></app-video>
        <app-audio *ngIf="interactionType.value === 'audio'" (addInteraction)="addInteraction($event)"></app-audio>
    </div>
</app-card>